import { gql } from '@apollo/client';

export const GET_COURSES = gql`
  query GetCourses($locale: String) {
    courses(locale: $locale) {
      id
      slug
      title
      description
      weeksLabel
      durationLabel
      thumbnailUrl
      order
      moduleCount
      freeModuleCount
      progressPercent
      ungroupedModules {
        id
        title
        videoUrl
        thumbnailUrl
        isFree
        order
        isLocked
        isCompleted
      }
      moduleGroups {
        id
        label
        order
        modules {
          id
          title
          videoUrl
          thumbnailUrl
          isFree
          order
          isLocked
          isCompleted
        }
      }
    }
  }
`;

export const MARK_COURSE_MODULE_COMPLETED = gql`
  mutation MarkCourseModuleCompleted($moduleId: ID!) {
    markCourseModuleCompleted(moduleId: $moduleId) {
      id
      isCompleted
      isLocked
      videoUrl
    }
  }
`;

export const GET_COURSE_BY_SLUG = gql`
  query GetCourseBySlug($slug: String!, $locale: String) {
    course(slug: $slug, locale: $locale) {
      id
      slug
      title
      description
      weeksLabel
      durationLabel
      thumbnailUrl
      order
      moduleCount
      freeModuleCount
      progressPercent
      price
      isPurchasable
      ownedByViewer
      ungroupedModules {
        id
        title
        description
        videoUrl
        thumbnailUrl
        transcriptUrl
        chapters {
          title
          startSeconds
        }
        isFree
        order
        isLocked
        isCompleted
      }
      moduleGroups {
        id
        label
        order
        modules {
          id
          title
          description
          videoUrl
          thumbnailUrl
          transcriptUrl
          chapters {
            title
            startSeconds
          }
          isFree
          order
          isLocked
          isCompleted
        }
      }
    }
  }
`;

export const CREATE_COURSE_PURCHASE_PIX = gql`
  mutation CreateCoursePurchasePix(
    $slug: String!
    $documentType: String!
    $documentNumber: String!
    $phone: String!
    $phoneDetails: CoursePurchasePhoneInput
    $couponCode: String
  ) {
    createCoursePurchasePix(
      slug: $slug
      documentType: $documentType
      documentNumber: $documentNumber
      phone: $phone
      phoneDetails: $phoneDetails
      couponCode: $couponCode
    ) {
      purchase_id status amount pix_code pix_qr_code_url expires_at
    }
  }
`;
export const CREATE_COURSE_PURCHASE_CHECKOUT = gql`
  mutation CreateCoursePurchaseCheckout(
    $slug: String!
    $phone: String!
    $phoneDetails: CoursePurchasePhoneInput
    $returnUrl: String!
    $cancelUrl: String
    $couponCode: String
  ) {
    createCoursePurchaseCheckout(
      slug: $slug
      phone: $phone
      phoneDetails: $phoneDetails
      returnUrl: $returnUrl
      cancelUrl: $cancelUrl
      couponCode: $couponCode
    ) {
      purchase_id url amount
    }
  }
`;
export const VALIDATE_COURSE_COUPON = gql`
  query ValidateCourseCoupon($code: String!, $slug: String!) {
    validateCourseCoupon(code: $code, slug: $slug) {
      valid
      error
      code
      type
      discount
      amount
    }
  }
`;
export const COURSE_PURCHASE_STATUS = gql`
  query CoursePurchaseStatus($purchaseId: ID!) {
    coursePurchaseStatus(purchaseId: $purchaseId) { status }
  }
`;
